import { useQuery } from '@tanstack/react-query';
import { moodleQueryKeys } from '../all-query-keys';
import { getConfiguredCourses } from '../../../services/MoodleService';

export const useGetConfiguredCourses = ({
  page,
  size,
  enabled = true,
} = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: moodleQueryKeys.getConfiguredCourses(page, size),
    queryFn: () => getConfiguredCourses(page, size),
    enabled,
  });

  const configuredCourses = data?.data?.content || data?.data || [];
  const totalPages = data?.data?.totalPages || 0;
  const totalElements = data?.data?.totalElements || 0;

  return { configuredCourses, totalPages, totalElements, loading: isLoading };
};
